import { render, staticRenderFns } from "./DataPoints.vue?vue&type=template&id=0004649a&scoped=true&"
import script from "./DataPoints.vue?vue&type=script&lang=ts&"
export * from "./DataPoints.vue?vue&type=script&lang=ts&"
import style0 from "./DataPoints.vue?vue&type=style&index=0&id=0004649a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0004649a",
  null
  
)

export default component.exports